export default __webpack_public_path__ + "static/media/cards.1ffbe212.png";